module.exports = __webpack_public_path__ + "static/assets/1ceb00cd249c27ef52a490dcf8042859.svg";